import { useLingui as _useLingui } from "../../lib/i18n/useLingui";
import { Checkbox } from "../../components/Checkbox";
import { radioIndicatorStyles, radioStyles } from "../../components/RadioGroup";
import { cn } from "../../lib/utils";
import React from "react";
function getSelectionLabel(t, table, row) {
  var _table$options$meta, _table$options$meta$g;
  const label = (_table$options$meta = table.options.meta) === null || _table$options$meta === void 0 || (_table$options$meta$g = _table$options$meta.getRowLabel) === null || _table$options$meta$g === void 0 ? void 0 : _table$options$meta$g.call(_table$options$meta, row.original);
  return label ? t(
  /** i18n */
  {
    id: "pov_PW",
    message: "Select {label}",
    values: {
      label: label
    }
  }) : t(
  /** i18n */
  {
    id: "9c44h0",
    message: "Select row"
  });
}
function SelectAllCheckbox({
  table
}) {
  const {
    _: _t
  } = _useLingui();
  return /*#__PURE__*/React.createElement(Checkbox, {
    "aria-label": _t(
    /** i18n */
    {
      id: "_fhMKz",
      message: "Select all rows"
    }),
    checked: table.getIsAllRowsSelected() ? true : table.getIsSomeRowsSelected() ? "partial" : false,
    onCheckedChange: state => {
      if (state === "indeterminate") {
        return;
      }
      table.toggleAllRowsSelected(state);
    }
  });
}
function SelectRowCheckbox({
  table,
  row
}) {
  const {
    _: _t2
  } = _useLingui();
  return /*#__PURE__*/React.createElement("div", {
    className: "flex h-full w-full items-center"
  }, /*#__PURE__*/React.createElement(Checkbox, {
    "aria-label": getSelectionLabel(_t2, table, row),
    checked: row.getIsSelected(),
    disabled: !row.getCanSelect(),
    onCheckedChange: state => {
      if (state === "indeterminate") {
        return;
      }
      row.toggleSelected(state);
    }
  }));
}
function SelectRowRadio({
  table,
  row
}) {
  const {
    _: _t3
  } = _useLingui();
  return /*#__PURE__*/React.createElement("div", {
    className: "flex h-full w-full items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: cn(radioStyles(), row.getIsSelected() && "bg-muted/50", !row.getCanSelect() && "cursor-not-allowed opacity-50"),
    "aria-checked": row.getIsSelected(),
    "aria-label": getSelectionLabel(_t3, table, row),
    role: "radio"
  }, row.getIsSelected() && /*#__PURE__*/React.createElement("div", {
    className: radioIndicatorStyles()
  })));
}

/** Builds a checkbox column for multi-row selection, with an optional select-all header. */
export function createSelectionColumn({
  hideSelectAll = false
} = {}) {
  return {
    id: "select",
    enableSorting: false,
    enableHiding: false,
    header: ({
      table
    }) => !hideSelectAll ? /*#__PURE__*/React.createElement(SelectAllCheckbox, {
      table: table
    }) : null,
    cell: ({
      row,
      table
    }) => /*#__PURE__*/React.createElement(SelectRowCheckbox, {
      table: table,
      row: row
    }),
    meta: {
      className: "w-10 min-w-10"
    }
  };
}

/** Builds a radio column for single-row selection. */
export function createRadioSelectionColumn() {
  return {
    id: "radio-select",
    enableSorting: false,
    enableHiding: false,
    header: () => null,
    cell: ({
      row,
      table
    }) => /*#__PURE__*/React.createElement(SelectRowRadio, {
      table: table,
      row: row
    }),
    meta: {
      className: "w-10 min-w-10"
    }
  };
}
//# sourceMappingURL=selection.js.map